import firebase from 'firebase/app';

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBujjli6On6sNz-GxOqscfTzS8P6nmyoz8",
  authDomain: "acri-vhls-challenge.firebaseapp.com",
  databaseURL: "https://acri-vhls-challenge-default-rtdb.firebaseio.com",
  projectId: "acri-vhls-challenge",
  storageBucket: "acri-vhls-challenge.appspot.com",
  messagingSenderId: "725248967957",
  appId: "1:725248967957:web:f773f298b8dd301717951c",
  measurementId: "G-DXT99J9KS6"
};

firebase.initializeApp(firebaseConfig);

export default firebase;
